import {
  ContentResponse,
  UserPointsResponse,
} from "../services/api.response.service";
import { ResourceTypes } from "../services/app.service";

/** Flatten all Point records from content.user_points (PointResponse[]) */
function getPoints(content: ContentResponse): Array<UserPointsResponse> {
  if (!content?.user_points?.length) return [];
  return content.user_points as UserPointsResponse[];
}

export function getCompletedWatchCount(content: ContentResponse): number {
  return getPoints(content).filter((p) => p.where.toLowerCase() === "watch")
    .length;
}

export function getTotalWatchCount(content: ContentResponse): number {
  if (!content?.content_resources?.length) return content?.total_videos ?? 0;
  return content.content_resources.filter((r) => r.type === ResourceTypes.VIDEO)
    .length;
}

export function getCompletedListenCount(content: ContentResponse): number {
  return getPoints(content).filter((p) => p.where.toLowerCase() === "listen")
    .length;
}

export function getTotalListenCount(content: ContentResponse): number {
  if (!content?.content_resources?.length) return content?.total_audios ?? 0;
  return content.content_resources.filter((r) => r.type === ResourceTypes.AUDIO)
    .length;
}

export function getCompletedReadCount(content: ContentResponse): number {
  if (!content?.has_read) return 0;
  const hasReadPoint = getPoints(content).some((p) => p.where === "read");
  return hasReadPoint ? 1 : 0;
}

export function getTotalReadCount(content: ContentResponse): number {
  return content?.has_read ? 1 : 0;
}

export function getCompletedTestCount(content: ContentResponse): number {
  if (!content?.tests?.length) return 0;
  const points = getPoints(content);
  const testPoints = points.filter(
    (p) => p.where === "test" || p.where === "test_result",
  );
  return testPoints.length;
}

export function getTotalTestCount(content: ContentResponse): number {
  return content?.tests?.length ?? 0;
}

export function getCompletedPracticeCount(content: ContentResponse): number {
  if (!content?.has_practice) return 0;
  const hasPoint = getPoints(content).some((p) => p.where === "practice");
  return hasPoint ? 1 : 0;
}

export function getTotalPracticeCount(content: ContentResponse): number {
  return content?.has_practice ? 1 : 0;
}
